import { ChangeEvent, FC, ReactElement } from 'react'

import { ErrorLabel, HTMLInputProps, Input } from '@/components'

import './TextInput.scss'

export interface TextInputProps extends Omit<HTMLInputProps, 'onChange'> {
    error?: string
    inputClassName?: string
    type: HTMLInputProps['type']
    onChange?: (value: string) => void
}

export const TextInput: FC<TextInputProps> = ({
    error,
    type = 'text',
    className = '',
    inputClassName,
    onChange,
    ...inputProps
}): ReactElement => {
    const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
        if (onChange) {
            onChange(event.currentTarget.value)
        }
    }

    return (
        <div className={`text-input ${className}`}>
            <Input
                {...inputProps}
                type={type}
                className={`text-input__input ${inputClassName}`}
                onChange={handleChange}
            />
            {error && <ErrorLabel text={error} className="text-input__error-label" />}
        </div>
    )
}
